import React from 'react';
import { Link } from 'react-router-dom';
import { HomeNavbar } from '../home/HomeNavbar';

export const LegalLayout = ({ title, updated, intro, sections, testid }) => (
  <div className="min-h-screen bg-white text-[#0F0F0F]" data-testid={testid}>
    <HomeNavbar />
    <main className="max-w-3xl mx-auto px-6 py-16 md:py-24">
      <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF451A] mb-4">Legal</div>
      <h1 className="text-4xl sm:text-5xl font-bold tracking-tight mb-3" data-testid={`${testid}-title`}>{title}</h1>
      <p className="text-sm text-[#6B7280] mb-10" data-testid={`${testid}-updated`}>Last updated: {updated}</p>
      <p className="text-base text-[#4B5563] leading-relaxed mb-12">{intro}</p>
      <div className="space-y-10">
        {sections.map((s) => (
          <section key={s.heading}>
            <h2 className="text-lg font-semibold mb-3">{s.heading}</h2>
            {s.body.map((p, i) => (
              <p key={i} className="text-base text-[#4B5563] leading-relaxed mb-3">{p}</p>
            ))}
          </section>
        ))}
      </div>
    </main>
    <footer className="border-t border-black/[0.06] py-8">
      <div className="max-w-3xl mx-auto px-6 flex flex-wrap items-center justify-between gap-4 text-sm text-[#6B7280]">
        <span>© 2026 Vyvre. All rights reserved.</span>
        <div className="flex gap-6">
          <Link to="/privacy" className="hover:text-[#FF451A] transition-colors" data-testid="legal-footer-privacy">Privacy</Link>
          <Link to="/terms" className="hover:text-[#FF451A] transition-colors" data-testid="legal-footer-terms">Terms</Link>
          <a href="mailto:hello@vyvre.in" className="hover:text-[#FF451A] transition-colors" data-testid="legal-footer-contact">hello@vyvre.in</a>
        </div>
      </div>
    </footer>
  </div>
);
